module.exports = __webpack_public_path__ + "assets/img/index-leftmenu-bg@2x.0ff77673.png";